<template>
  <div class="maincont px-2 py-3">
    <div class="widget px-0">
      <div class="d-flex" style="justify-content: space-between">
        <span class="title"
          >Липидный профиль
          <div class="subtitle">{{ date }}</div></span
        >
        <div
          class="lock-icon"
          :style="{
            background:
              !date && !cholesterol && !tg && !lpvp && !lpnp
                ? '#a3a3a3'
                : '#f59e0b',
          }"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            width="20px"
            height="20px"
            xmlns="http://www.w3.org/2000/svg"
            stroke="#ffffff"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 0.827576L12.8878 2.53967C14.1035 4.88434 15.5212 6.51667 16.8024 7.99192C16.9893 8.20708 17.1733 8.41891 17.3533 8.62911C18.7331 10.2403 20 11.8793 20 14.1696C20 18.5172 16.395 22 12 22C7.60499 22 4 18.5172 4 14.1696C4 11.8793 5.26687 10.2403 6.64671 8.62911C6.82673 8.41891 7.0107 8.20708 7.19757 7.99191C8.47882 6.51667 9.89649 4.88434 11.1122 2.53967L12 0.827576ZM8.16579 9.93003C6.7748 11.5543 6 12.6877 6 14.1696C6 17.3667 8.66302 20 12 20C15.337 20 18 17.3667 18 14.1696C18 12.6877 17.2252 11.5543 15.8342 9.93003C15.664 9.73133 15.4862 9.5269 15.3024 9.31552C14.2961 8.15864 13.1087 6.79342 12 5.0167C10.8913 6.79342 9.70387 8.15864 8.69763 9.31552C8.51377 9.5269 8.33596 9.73133 8.16579 9.93003Z"
                fill="#ffffff"
              ></path>
            </g>
          </svg>
        </div>
      </div>
      <div class="col-12" v-if="date || cholesterol || tg || lpvp || lpnp">
        <div class="widget-row">
          <span class="label">Холестерин</span>
          <span class="value"
            >{{ cholesterol
            }}<span v-if="dyn_total_cholesterol === 1" style="color: #4caf50"
              >&#9660;</span
            ><span v-if="dyn_total_cholesterol === 2" style="color: #f44336"
              >&#9650;</span
            ><span v-if="dyn_total_cholesterol === 0" style="color: #f8f9fa"
              >&#9650;</span
            >
          </span>
        </div>
        <div class="widget-row">
          <span class="label">ТГ</span>
          <span class="value"
            >{{ tg
            }}<span v-if="dyn_tg === 1" style="color: #4caf50">&#9660;</span
            ><span v-if="dyn_tg === 2" style="color: #f44336">&#9650;</span>
            <span v-if="dyn_tg === 0" style="color: #f8f9fa">&#9650;</span>
          </span>
        </div>
        <div class="widget-row">
          <span class="label">ЛПВП</span>
          <span class="value"
            >{{ lpvp
            }}<span v-if="dyn_lpvp === 1" style="color: #f44336">&#9660;</span
            ><span v-if="dyn_lpvp === 2" style="color: #4caf50">&#9650;</span>
            <span v-if="dyn_lpvp === 0" style="color: #f8f9fa">&#9650;</span>
          </span>
        </div>
        <div class="widget-row">
          <span class="label">ЛПНП</span>
          <span class="value"
            >{{ lpnp
            }}<span v-if="dyn_lpnp === 1" style="color: #4caf50">&#9660;</span
            ><span v-if="dyn_lpnp === 2" style="color: #f44336">&#9650;</span>
            <span v-if="dyn_lpnp === 0" style="color: #f8f9fa">&#9650;</span>
          </span>
        </div>
      </div>
      <div v-else class="notification py-3">Данные пока не внесены</div>
    </div>
    <div class="cta-button mb-0">
      {{
        cholesterol || tg || lpvp || lpnp ? "Мои результаты" : "Внести данные"
      }}
    </div>
  </div>
</template>
<script lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import { defineComponent } from "vue";
import { fetchLatestLipidsData } from "@/services/api";

export default defineComponent({
  name: "LipProfileWidget",
  setup() {
    const green = "#11b981";
    const yellow = "#eedc4e";
    const red = "#fc6b6b";

    const cholesterol = ref(0);
    const dyn_total_cholesterol = ref(0);
    const tg = ref(0);
    const dyn_tg = ref(0);
    const lpvp = ref(0);
    const dyn_lpvp = ref(0);
    const lpnp = ref(0);
    const dyn_lpnp = ref(0);
    const date = ref("");

    const updateData = async () => {
      const data = await fetchLatestLipidsData();
      if (data) {
        cholesterol.value = data.total_cholesterol ?? 0;
        dyn_total_cholesterol.value = data.dyn_total_cholesterol ?? 0;
        tg.value = data.tg ?? 0;
        dyn_tg.value = data.dyn_tg ?? 0;
        lpvp.value = data.hdl ?? 0;
        dyn_lpvp.value = data.dyn_hdl ?? 0;
        lpnp.value = data.ldl ?? 0;
        dyn_lpnp.value = data.dyn_ldl ?? 0;
        const dateObj = new Date(data.date ?? Date.now());
        const day = String(dateObj.getDate()).padStart(2, "0");
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const year = dateObj.getFullYear();
        date.value = `${day}.${month}.${year}`;
      } else {
        console.warn("Данные липидограммы не найдены.");
      }
    };

    let intervalId: number;

    onMounted(() => {
      updateData();
      intervalId = window.setInterval(updateData, 5000); // Проверка каждые 5 секунд
    });

    onUnmounted(() => {
      clearInterval(intervalId);
    });

    return {
      cholesterol,
      tg,
      lpvp,
      lpnp,
      green,
      yellow,
      red,
      dyn_total_cholesterol,
      dyn_tg,
      dyn_lpvp,
      dyn_lpnp,
      date,
    };
  },
  components: {},
});
</script>
<style scoped>
.maincont {
  width: 100%;
  align-items: center;
}
.widget {
  width: 100%;

  padding: 5px;
}

.widget-row {
  display: flex;
  justify-content: space-between;
  border-bottom: 0px solid #2c2c2e;
  line-height: 1.2;
}

.widget-row:last-child {
  border-bottom: none;
}

.label {
  font-size: 14px;
}

.value {
  font-size: 14px;
  color: #000000;
}
.title {
  color: #2c3d50;
  font-size: 12pt;
  font-weight: 500;
  line-height: 0.9;
  margin-bottom: 1px;
}
.subtitle {
  color: #2c3d50;
  font-size: 9pt;
  font-weight: 500;
  line-height: 1.1;
  margin-bottom: 4px;
  margin-top: 4px;
}

.lock-icon {
  background: #f59e0b;
  padding: 8.5px;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  max-width: 30px;
  min-width: 30px;
  max-height: 30px;
  display: flex;
  align-content: center;
  align-items: center;
  box-shadow: 1px 1px 16px 0px #dddddd;
}
.cta-button {
  /*  background: #2c3d50; */

  color: #2c3d50;
  padding: 8px 10px;
  border-radius: 12px;
  font-size: 10pt;
  font-weight: 500;
  text-align: center;
  /* margin-bottom: 10px; */
  border: 1px solid #a3a3a3;
}
.notification {
  color: #2c3d50;
  font-size: 11pt;

  text-align: center;
  text-align: center;
  line-height: 1;
  font-weight: 600;
}
</style>
